import * as React from 'react'
import MuiLink from '@mui/material/Link';

export const Link = (props) => {
  return <MuiLink {...props} underline="hover" />
}
